import { UPDATE_HEADER_TITLE } from "./singleOrder.constant";

/* Actions */
import { updateHeaderTitle } from "./singleOrder.action";

const initialState: SingleOrder = {
  isUpdateTitle: false,
};

type SingleOrderAction = ReturnType<typeof updateHeaderTitle>;

export function singleOrderReducer(state = initialState, action: SingleOrderAction): SingleOrder {
  switch (action.type) {
    case UPDATE_HEADER_TITLE:
      return { ...state, isUpdateTitle: action.payload };
    default:
      return state;
  }
}
